import React, { useState, useEffect } from "react";
import { useLocation, Outlet, useNavigate, Link, useParams, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./admin.css";
import axios from "axios";

// Configure API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function AdminLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isValidating, setIsValidating] = useState(true);
    const token = localStorage.getItem("token");
    const navigate = useNavigate();
    const location = useLocation();
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        console.log("Closing sidebar");
        setSidebarOpen(false);
    };

    // Validate token only on component mount
    useEffect(() => {
        const validateToken = async () => {
            // If no token, redirect to login
            if (!token) {
                console.log("No token found, redirecting to login");
                navigate("/admin/login");
                setIsValidating(false);
                return;
            }

            try {
                // Validate token with backend
                const response = await axios({
                    method: 'get',
                    url: `${API_BASE_URL}/token-is-valid`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.data && response.data.valid) {
                    // Token is valid

                    setIsValidating(false);
                } else {
                    // Token is invalid

                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    navigate("/admin/login");
                    setIsValidating(false);
                }
            } catch (error) {


                // Check if error is due to invalid token
                if (error.response && error.response.status === 401) {
                    console.log("Invalid token, removing and redirecting");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    navigate("/admin/login");
                } else {
                    // Other error - still redirect to login for safety
                    console.log("Error validating token, redirecting to login");
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    navigate("/admin/login");
                }
                setIsValidating(false);
            }
        };

        validateToken();
    }, []); // Empty dependency array - runs only once on mount

    // Show loading while validating
    if (isValidating) {
        return (
            <div className="admin-container">
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Validating session...</span>
                        </div>
                        <p className="mt-3">Validating your session...</p>
                    </div>
                </div>
            </div>
        );
    }
    if (location.pathname === '/admin' || location.pathname === '/admin/') {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return (
        <div className="admin-container">
            <div className="sidebar-wrapper">
                <Sidebar
                    isOpen={sidebarOpen}
                    onClose={closeSidebar}
                />
            </div>
            {sidebarOpen && <div className="sidebar-overlay open" onClick={closeSidebar}></div>}
            <div className="admin-main">
                <Topbar onMenuClick={toggleSidebar} />
                <div className="admin-content">

                    <Outlet />
                </div>
            </div>

        </div>
    );
}

export default AdminLayout;